export { default as TemplateApi } from "./template.api";
export * from "./template.type";
